import React, { useEffect, useRef, useState } from 'react'
import { Easing, Tween, update } from '@tweenjs/tween.js'
import {
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material'
import { crimeData, crimeDataNew } from '../mock/CrimeData.js'
import MenuList from '../components/MenuList'
import { Margin } from '@mui/icons-material'

const Analytics = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }
  return (
    <div>
      <div className='flex items-center space-x-4'>
        <MenuList isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <h1 className='font-semibold py-2 text-2xl text-orange-600'>
          Analytics
        </h1>
      </div>
      <div className='analytics-container'>
        <iframe
          width='90%'
          height='600'
          src='https://lookerstudio.google.com/embed/reporting/2d04704f-cc6f-4170-aba7-34c2352ef939/page/g6fuE'
          frameborder='0'
          style={{ border: '0', margin: '0 auto' }}
          allowfullscreen
          sandbox='allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
        ></iframe>
      </div>
    </div>
  )
}

export default Analytics
